import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: (() => {
      try {
        const userInfoStr = localStorage.getItem('userInfo');
        return userInfoStr ? JSON.parse(userInfoStr) : {};
      } catch (error) {
        console.error('解析用户信息失败:', error);
        return {};
      }
    })(),
    tabs: [],
    activeTab: ''
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
	  state.tabs=[]
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    ADD_TAB(state, tab) {
      const exists = state.tabs.some(t => t.path === tab.path)
      if (!exists) {
        state.tabs.push(tab)
      }
      state.activeTab = tab.path
    },
    REMOVE_TAB(state, path) {
      // 仪表盘页面不能被关闭
      if (path === '/dashboard') {
        return
      }
      state.tabs = state.tabs.filter(tab => tab.path !== path)
      if (state.activeTab === path && state.tabs.length > 0) {
        state.activeTab = state.tabs[state.tabs.length - 1].path
      }
    },
    SET_ACTIVE_TAB(state, path) {
      state.activeTab = path
    }
  },
  actions: {
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      
      // 设置axios默认授权头
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    logout({ commit }) {
      commit('LOGOUT')
      
      // 清除axios授权头
      delete axios.defaults.headers.common['Authorization']
    },
    addTab({ commit }, tab) {
      commit('ADD_TAB', tab)
    },
    removeTab({ commit }, path) {
      commit('REMOVE_TAB', path)
    },
    setActiveTab({ commit }, path) {
      commit('SET_ACTIVE_TAB', path)
    }
  },
  getters: {
    isAuthenticated: state => !!state.token,
    userInfo: state => state.userInfo,
    tabs: state => state.tabs,
    activeTab: state => state.activeTab
  }
})
